/**
 * Признак конструктора — одна функция на весь кабинет (WEB-467; WEB-3764,
 * доводка холста): адреса квиза, пейволла и холста воронки, на которых кабинет —
 * приложение во весь экран (`main.full` в `DashboardLayout.tsx`). Холст
 * `/funnels/:id/edit` — тоже конструктор (эталон `sections/editor.jsx:11`,
 * `layout: 'full'`): без него карта падала на нижнюю границу 320 px.
 */
export function isEditorRoute(pathname: string): boolean {
  return /\/(quizzes|paywalls|funnels)\/[^/]+\/edit$/.test(pathname);
}
